export default __webpack_public_path__ + "static/media/facebook.1c0ce642.svg";